import { FC, useEffect, useState } from 'react';

import { PagesApi } from '../../../api/payment-and-delivery';
import { useActions } from '../../../hooks/useActions';
import { useMain } from '../../../hooks/useMain';
import '../../../pages/PublicationCard/PublicationCard.sass';
import { CustomEditor } from '../../Editor';

import { CompanyPagesContaner } from './CompanyPagesContaner';

interface ICompanyPages {
  type: 'payment' | 'for-organizations' | 'o-proekte' | 'articles';
  title: 'Оплата и доставка' | 'Юридическим лицам' | 'О проекте' | 'Статьи';
}

export const CompanyPages: FC<ICompanyPages> = ({ type, title }) => {
  const { fetchMainCatalog, setPage, setProcesses } = useActions();
  //Начальное значение редактора HTML
  const [initialValue, setInitialValue] = useState(undefined as any);

  const { processes } = useMain();

  useEffect(() => {
    (async () => {
      try {
        const data = await PagesApi().getPages(type);
        setInitialValue(data.page.content);
        //Если ошибка, выдаем следующее
        if (data.error) {
          alert(
            'Произошла ошибка попробуйте еще раз или перезагрузите страницу'
          );
        }
      } catch (error) {
        if (error instanceof Error) {
          return console.log(error.message);
        } else {
          return console.log('Loading Error');
        }
      }
    })();
  }, []);

  useEffect(() => {
    setPage('publication'); //На какай странице находимся
    fetchMainCatalog(); //Получение процессов
  }, []);

  useEffect(() => {
    setProcesses(processes);
  }, [processes]);

  return (
    <CompanyPagesContaner title={title}>
      <div className="payment-and-delivery">
        <CustomEditor initialValue={initialValue} type={type} />
      </div>
    </CompanyPagesContaner>
  );
};
